import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionFileCabinetFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		requisitionId?: any;
		fileCabinetId?: any;
}

export class RequisitionFileCabinetFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public requisitionId: IEntityModelField = { name: "requisitionId", displayName: "Requisition Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public fileCabinetId: IEntityModelField = { name: "fileCabinetId", displayName: "File Cabinet Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.requisitionId);
		this.push(this.fileCabinetId);
	}
}

export class RequisitionFileCabinetDTO implements IEntityModel {
	protected requisitionFileCabinetName: string = "RequisitionFileCabinetModel";
	protected requisitionFileCabinetKeyField: string = "id";
	protected requisitionFileCabinetDisplayName: string = "Requisition File Cabinet|Requisition File Cabinets";
	protected requisitionFileCabinetFields = new RequisitionFileCabinetFields();
	public get name(): string { return this.requisitionFileCabinetName };
	public get keyField(): string { return this.requisitionFileCabinetKeyField };
	public get displayName(): string { return this.requisitionFileCabinetDisplayName };
	public get fields(): RequisitionFileCabinetFields { return this.requisitionFileCabinetFields };

	constructor() {};
}
